export default "__VITE_ASSET__CYJAB7Nw__"